<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="导入时间：">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>                
            </el-form-item>
            <el-form-item label="回收方：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getSimRecoveryListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getSimRecoveryListHandler" >查询</el-button>
                <el-button type="success"  plain icon="el-icon-s-ticket" @click="importCardVisible = true">批量回收</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}">     
            <el-table-column prop="startIccid" label="开始ICCID号" align="center"></el-table-column>
            <el-table-column prop="endIccid" label="结束ICCID号" align="center"></el-table-column>
            <el-table-column prop="agentName" label="回收方" align="center"></el-table-column>
            <el-table-column prop="recoverTotal" label="回收总数" align="center"></el-table-column>
            <el-table-column prop="recoverSuccess" label="回收成功数" align="center"></el-table-column>
            <el-table-column prop="recoverFail" label="回收失败数" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.recoverFail > 0" type="text" size="small" @click="getSimRecoveryFailListHandler(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog :append-to-body="true"  title="回收失败卡列表" :visible.sync="recoveryFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="failReason" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination> 
        </el-dialog>


        <el-dialog :append-to-body="true" title="批量回收" :visible.sync="importCardVisible" width="600px" @close="cancelImport" >
            <el-upload ref="upload" :action="uploadUrl('sim/recoverList/excel')" :headers="setHeader()" :auto-upload="false" :on-change="handleChange" :on-success="handleSuccess" >
                <el-button slot="trigger" plain>导入Excel</el-button>
                <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
            </el-upload>                        
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
                <el-button type="primary" @click="sureImportHandler">确 定</el-button>
            </div> 
        </el-dialog> 


    </div>
</template>
<script>
import {getSimRecoveryList, getSimRecoveryFailList} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                time: '',
                agentName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            recoveryFailVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },    
            currentId_fail: '',

            //批量回收操作
            importCardVisible: false,
            importFileList: [],
        }
    },
    methods: {
        getSimRecoveryListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSimRecoveryList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getSimRecoveryFailListHandler(id, $event){
            this.recoveryFailVisible = true;
            this.currentId_fail = id
            var searchForm = {
                recordId: this.currentId_fail 
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getSimRecoveryFailList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        handleSizeChange(val){
            if(this.recoveryFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getSimRecoveryFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getSimRecoveryListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.recoveryFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getSimRecoveryFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getSimRecoveryListHandler();
            }
        },

        //  批量回收操作
        handleChange(file, fileList) {
            if(fileList.length > 1){//只取最新一个文件
                fileList.splice(0,1);
            }
            
        },
        sureImportHandler(){
            if (this.$refs.upload.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.upload.submit();   
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getSimRecoveryListHandler();
                this.$message.success(res.message);
                this.cancelImport();
            }else{
                this.$message.error(res.message);
            }
            
        },

        cancelImport(){
            this.$refs.upload.clearFiles();
            this.importCardVisible = false;
        }
        //  批量回收操作  end  
    },
    created () {
        this.getSimRecoveryListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

